import { gql } from '@apollo/client';

export type GetTokenVariables = {
  name: string;
};

export const getTokenQuery = gql`
  query getToken($name: String!) {
    getToken(name: $name) {
      name
      displayName
      supply
      circulating
      address
      chainId
      price
      price_24h_change
    }
  }
`;
